import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findMotorCreditoRegra from '../../service/findMotorCredito';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';




export default function MotorCreditoList({onEdit}:{onEdit:(motorCredito:any)=>void}) {
  const { t } = useTranslation();
  const [motores, setMotores] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: 'descricao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findMotorCreditoRegra(lazyState).then(data => {setTotalRecords(data.total);setMotores(data.motores)}).catch(() => {setTotalRecords(0);setMotores(undefined)});
  }

  const editBodyTemplate = (servico:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(servico)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };
  
  useEffect(() => {
    loadLazyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lazyState])

  return (
    <div>
      <div>
        <DataTable value={motores} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           
           <Column field="descricao" sortable header={t('descricao')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


